import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setRedirectAfterLogin } from 'store/auth/authSlice';

type RedirectFunction = () => void;
type SetRedirectFunction = (redirectPath: string) => void;
type UseAuthRedirectType = {
    redirect: RedirectFunction;
    setRedirect: SetRedirectFunction;
};

export function useAuthRedirect(): UseAuthRedirectType {
    const { redirectAfterLogin } = useAppSelector((state) => state.auth);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const setRedirect = (redirectPath: string) => {
        dispatch(setRedirectAfterLogin(redirectPath));
    };

    const redirect = () => {
        if (redirectAfterLogin) {
            navigate(redirectAfterLogin);
            dispatch(setRedirectAfterLogin(null));
        } else {
            navigate('/');
        }
    };

    return {
        redirect,
        setRedirect,
    };
}
